import moment from 'moment-timezone';
import { uniqBy, sortBy } from 'lodash';

const getTimezoneEntry = (timezone) => {
  const name = moment.tz(timezone).format('z');
  return {
    value: timezone,
    abbr: moment.tz(timezone).zoneAbbr(),
    name,
  };
};

const getTimeZoneName = (tz) => {
  const timezone = fullTimezonesList.find((timezone) => timezone.value === tz);
  return timezone?.abbr || 'NA';
};

const fullTimezonesList = TIMEZONE_COUNTRY_LIST.map((countryCode) =>
  moment.tz
    .zonesForCountry(countryCode)
    .map((timezone) => getTimezoneEntry(timezone)),
).flat();
const timezones = sortBy(uniqBy(fullTimezonesList, (tz) => tz.name), (tz) => tz.name);

const getTimezones = () => {
  return timezones;
};

const getAllCountryTimezones = () => {
  return sortBy(fullTimezonesList, (tz) => tz.name);
};

export { getAllCountryTimezones, getTimezones, getTimeZoneName };
